import { mergeStyles } from '../../../../internal/utils';
import * as mainStyles from './styles.module.css';
export var getStyles = function getStyles(size) {
  return mergeStyles(mainStyles, require("./size/".concat(size, ".module.css")));
};